// Ponte entre o código portado do ca-service-level e a autenticação do iexp.
// O login/senha/sessão são 100% do iexp; aqui só expomos a identidade e as
// preferências locais de exibição (janela de referência).
import { getUserData } from '../../modules/auth';
import { JanelaRef, Usuario } from './types';

const PREF_KEY = 'sl_prefs';

// Perfil no shape que as telas portadas esperam. O escopo real (indústrias,
// BUs, carteira, nível) vem do backend em /service-level/me — nunca daqui.
export function getUser(): Usuario | null {
  const u = getUserData();
  if (!u) return null;
  return {
    id: 0,
    nome: u.name || u.email || 'Usuário',
    email: u.email,
    perfil: u.is_superadmin ? 'ADMIN' : 'GESTOR',
    ativo: true,
  } as Usuario;
}

export interface Prefs {
  janela_ref: JanelaRef;
  custom_de?: string;
  custom_ate?: string;
}

const chaveUsuario = () => getUserData()?.guid || 'anon';

export function getPrefs(): Prefs {
  try {
    const all = JSON.parse(localStorage.getItem(PREF_KEY) || '{}');
    return all[chaveUsuario()] ?? { janela_ref: 'YTD' };
  } catch {
    return { janela_ref: 'YTD' };
  }
}

export function setPrefs(p: Prefs) {
  try {
    const all = JSON.parse(localStorage.getItem(PREF_KEY) || '{}');
    all[chaveUsuario()] = p;
    localStorage.setItem(PREF_KEY, JSON.stringify(all));
  } catch {
    /* preferência é acessório: falha silenciosa não pode quebrar a tela */
  }
}
